export const CUSTOM_TAG_AVAILABLE_COLORS = [
  '#F27878',
  '#E9B737',
  '#6ECD6D',
  '#729CDA',
  '#BF72DA',
  '#7F4CEA',
  '#F14E9C',
  '#EC3434',
  '#EA7C4C',
  '#CACD39',
  '#90BC59',
  '#5AB2C6',
]
